export const fieldType = Object.freeze({
    custom: 0,
    topic: 1,
    plan: 3,
    description: 4,
    date: 5,
    classHours: 6,
    learningObjectivesCell: 7,
    resources: 8,
    activities: 9,
    rubric: 11,
    resourceAndActivitiesCell: 12,
    thumbnail: 13,
    topicThumbnail: 14,
    topicPlans: 15,
    default: 100
});

export const noTopicTopicId = 0;

export const tableViewMode = Object.freeze({
    plans: 0,
    topics: 1
});
